import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Button } from '../../../../../shared/model/enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { StepProgressbarComponent } from './step-progressbar/step-progressbar.component';
import { ConfirmSelectionTabComponent } from './confirm-selection-tab/confirm-selection-tab.component';
import { SendRequestTabComponent } from './send-request-tab/send-request-tab.component';
import { VendorPartsLibraryService } from '../../../vendor-parts-library/pages/vendor-parts-library/vendor-parts-library.service';

@Component({
  selector: "app-request-vendor-popup",
  templateUrl: "./request-vendor-popup.component.html",
  styleUrls: ["./request-vendor-popup.component.scss"],
})
export class RequestVendorPopupComponent implements OnInit {
  @ViewChild(StepProgressbarComponent)
  stepProgressbarComponent: StepProgressbarComponent;
  @ViewChild(ConfirmSelectionTabComponent)
  confirmSelectionComponent: ConfirmSelectionTabComponent;
  @ViewChild(SendRequestTabComponent)
  sendRequestComponent: SendRequestTabComponent;

  SelectVendorTabComponent;
  enumButtonName = Button;
  title;
  @Input() data: any = {};
  expirationDate;
  constructor(
    public activeModal: NgbActiveModal,
    public toaster: ToastrService,
    public renderer: Renderer2,
    public sendDataService: SendDataService,
    public vplService: VendorPartsLibraryService
  ) {}

  ngOnInit(): void {}
  onPrevClick() {
    this.stepProgressbarComponent?.onPrevClick();
  }
  onNextClick() {
    this.stepProgressbarComponent?.onNextClick();
    if (this.stepProgressbarComponent?.currentActive == 2)
      this.confirmSelectionComponent.triggerGridReady();
    if (this.stepProgressbarComponent?.currentActive == 3)
      this.sendRequestComponent.triggerGridReady();
  }
  isDisable(label: string): boolean {
    switch (label) {
      case "Previous":
        return this.stepProgressbarComponent?.currentActive === 1;
      case "Next":
        return (
          this.stepProgressbarComponent?.currentActive ===
          this.stepProgressbarComponent?.steps?.length
        );
      default:
        return false;
    }
  }
  onSendClick() {
   if (!this.data?.confirmedData || !Array.isArray(this.data.confirmedData) || !this.data.confirmedData.length ) {
     this.toaster.error('No rows selected to send.');
     return;
   }
    const vplRequestModel = {
      vplRequestModel: this.data.confirmedData.map((row: any) => ({
        id: row.id,
        vendorId: row.vendorId,
        vendorContactId: row.vendorContactId,
      })),
    };
    this.vplService.UpdateRequestVPL(vplRequestModel).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.toaster.success(res?.message);
          this.activeModal.close({ success: true, response: res });
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

}